module.exports = "varying vec3 vPosition;\r\nvarying vec3 vNormal;\r\nvarying vec2 vUv;\r\nvarying vec2 vUv2;\r\n\r\nvoid main()\r\n{\r\n  vNormal = normal;\r\n  vUv = uv;\r\n  vPosition = position;\r\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/app/services/lightMap/CloudMaterial/vertex.glsl
// module id = ./node_modules/raw-loader/index.js!./src/app/services/lightMap/CloudMaterial/vertex.glsl
// module chunks = main